import { createAction, props } from '@ngrx/store';

import {
  GenericServiceValue,
  PersonalDoctorValue,
  PharmacologicalTreatmentValue,
  PrescriptionFormValue,
} from '../models/prescription.interface';

export const addPrescriptionDraft = createAction(
  '[Prescriptions Page] Add prescription draft',
  props<{ draft: PrescriptionFormValue<PharmacologicalTreatmentValue | GenericServiceValue | PersonalDoctorValue> }>()
);

export const updatePrescriptionDraft = createAction(
  '[Prescriptions Page] Update prescription draft',
  props<{ draft: PrescriptionFormValue<PharmacologicalTreatmentValue | GenericServiceValue | PersonalDoctorValue> }>()
);

export const deletePrescriptionDraft = createAction(
  '[Prescriptions Page] Delete prescription draft',
  props<{ id: string }>()
);

export const clearPrescriptionDrafts = createAction('[Prescriptions] Clear prescription drafts');

export const loadPrescriptionDraftsFromStorage = createAction(
  '[Prescriptions Store] Load prescription drafts from storage',
  props<{ drafts: PrescriptionFormValue<PharmacologicalTreatmentValue | GenericServiceValue | PersonalDoctorValue>[] }>()
);
